import { injectable } from 'inversify';
import request, { RequestOptions } from 'graphql-request';
import type { Variables } from 'graphql-request';

import type { GetTokens, GqlConfig, MakeRequestParams, TokensContainer } from './types';

@injectable()
export class GqlService {
  private readonly getTokens: GetTokens;

  constructor(private config: GqlConfig, sessionService: TokensContainer) {
    this.getTokens = sessionService.getTokens;
  }

  public makeRequest = <QueryParams extends Variables, QueryResult>({
    requestOptions,
    needAuthorization,
    shouldSetEnvAutomatically
  }: MakeRequestParams<QueryParams, QueryResult>) => {
    const shouldSetEnvAutomaticallyWithFallback = shouldSetEnvAutomatically ?? true;
    const requestVariables = {
      ...(shouldSetEnvAutomaticallyWithFallback && { env: this.config.env }),
      ...requestOptions.variables
    };
    const processedRequestOptions = {
      ...requestOptions,
      ...{ variables: requestVariables }
    } as RequestOptions<QueryParams, QueryResult>;

    if (needAuthorization) {
      return this.getTokens().then(({ accessToken }) => {
        return request({
          url: this.config.gqlGatewayUrl,
          ...processedRequestOptions,
          requestHeaders: {
            ...{ authorization: `Bearer ${accessToken}` },
            ...requestOptions.requestHeaders
          }
        });
      });
    }

    return request({ url: this.config.gqlGatewayUrl, ...processedRequestOptions });
  };
}
